module.exports = __webpack_public_path__ + "static/media/unique_intro.e6397084.gif";


//////////////////
// WEBPACK FOOTER
// ./src/containers/static/landing/unique_intro.gif
// module id = 392
// module chunks = 0